import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    groupPaper: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: "solid 1px",
        boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
        height: "100%"
    },
    groupPaperWorstRated: {
        borderColor: theme.palette.error.main,
        backgroundColor: theme.palette.background.paper,
        border: "solid 2px",
        boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
        height: "100%"
    },
    groupPaper50: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: "solid 1px",
        boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
        marginBottom: 5
    },
    centeredRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'stretch',
        alignItems: 'center',
        width: "100%"
    },
    toggleButton: {
        width: "100%",
        height: 25
    },
    filterRow: {
        display: 'flex',
        flexWrap: "wrap",
        flexDirection: 'row',
        alignItems: 'center'
    },
    divider: {
        marginLeft: 25,
        marginRight: 25,
        background: 'darkgray',
        width: 1
    },
    smallPanelHeader: {
        ...theme.typography.h5,
        color: theme.palette.text.secondary,
        display: 'flex',
        justifyContent: "center"
    },
    formControl: {
        minWidth: 180,
        margin: theme.spacing(1),
        color: theme.palette.common.white
    },
    root: {
        marginTop: 15,
        display: 'flex',
        alignItems: "center",
        justifyContent: "center"
    },
    image: {
        display: 'flex',
        alignItems: "center",
        justifyContent: "center",
        marginTop: 20,
        marginBottom: 20,
        maxWidth: "50%",
        maxHeight: "50%",
        margin: "0 auto"
    }
}));

export {useStyles};